export enum TabNames {
    Requests = 'Requests',
    Draft = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected'
  }
  
  export enum TabLabels {
    Requests = 'Requests',
    Draft = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected'
 
  }
  
  export enum RequirementStatus {
    Requested = 'Requested',
    Draft = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected'
  }